import { render } from "./ModalWithdrawBtc.vue?vue&type=template&id=076d628c&scoped=true&ts=true"
import script from "./ModalWithdrawBtc.vue?vue&type=script&lang=ts"
export * from "./ModalWithdrawBtc.vue?vue&type=script&lang=ts"

import "./ModalWithdrawBtc.vue?vue&type=style&index=0&id=076d628c&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-076d628c"]])

export default __exports__